import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import axios from 'axios';

const TvShow = ({
                    title,
                    year,
                    image,
                    rating,
                    id,
                    type = "tv",
                    isFavorite: propIsFavorite,
                    isPartnerFavorite: propIsPartnerFavorite,
                    currentUserId,
                    partnerUserId,
                    savedBy
                }) => {
    const navigate = useNavigate();
    const currentUser = auth.currentUser;
    const [isFavorite, setIsFavorite] = useState(propIsFavorite || false);
    const imageUrl = "https://image.tmdb.org/t/p/w500" + image;

    useEffect(() => {
        if (currentUser?.uid && id) {
            if (propIsFavorite !== undefined) {
                setIsFavorite(propIsFavorite);
            } else {
                checkIfFavorite();
            }
        }
    }, [currentUser, id, propIsFavorite]);

    const checkIfFavorite = async () => {
        if (!currentUser?.uid) return;

        try {
            const response = await axios.get(`https://api.frazza.online/favorites/check/${currentUser.uid}/${type}/${id}`);
            setIsFavorite(response.data.isFavorite);
        } catch (error) {
            console.error("Error checking favorite status:", error);
        }
    };

    const handleShowClick = () => {
        navigate(`/dashboard/content/tv/${id}`);
    };

    const toggleFavorite = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!currentUser?.uid) {
            alert('Please sign in to save favorites');
            return;
        }

        try {
            // Determine which user's favorite to toggle
            let targetUserId = currentUser.uid;
            let forceRemove = false;

            if (!isFavorite && propIsPartnerFavorite && partnerUserId) {
                targetUserId = partnerUserId;
                forceRemove = true;
            }

            // Get user name for savedBy field
            let userName = currentUser.displayName || 'Unknown User';
            try {
                const userResponse = await axios.get(`https://api.frazza.online/user/${currentUser.uid}`);
                if (userResponse.data.success) {
                    userName = userResponse.data.data.firstName || userResponse.data.data.name || userName;
                }
            } catch (error) {
                console.error('Error fetching user info:', error);
            }

            // Prepare favorite item data
            const itemData = {
                id,
                title,
                year,
                image,
                rating,
                type,
                savedBy: userName
            };

            // Update favorites via API
            const response = await axios.post('https://api.frazza.online/favorites/toggle', {
                userId: targetUserId,
                itemData,
                forceRemove
            });

            // Update local state based on which user's favorites were modified
            if (targetUserId === currentUser.uid) {
                setIsFavorite(!isFavorite);
            }

        } catch (error) {
            console.error('Error updating favorite:', error);
        }
    };

    const renderSavedByIndicator = () => {
        if (!savedBy) return null;
        return (
            <span className="saved-by-badge">Saved by: {savedBy}</span>
        );
    };

    const renderRating = () => {
        if (rating === undefined || rating === null || rating === '') return null;
        const maxDots = 5;
        const numeric = typeof rating === 'number' ? rating : parseFloat(rating) || 0;
        const clamped = Math.max(0, Math.min(numeric, maxDots));
        const filled = Math.round(clamped);
        return (
            <div className="rating-display">
                {Array.from({ length: maxDots }, (_, i) => (
                    <span key={i} className={`rating-dot ${i < filled ? 'filled' : ''}`}></span>
                ))}
                <span className="rating-number">{numeric.toFixed(1)}</span>
            </div>
        );
    };

    return (
        <div className="tv-show-card" onClick={handleShowClick}>
            <div className="tv-show-image">
                <img src={imageUrl} alt={title} />
                {renderSavedByIndicator()}
                <button className="favorite-btn" onClick={toggleFavorite} aria-label="Toggle favorite">
                    {isFavorite || propIsPartnerFavorite ? (
                        <AiFillHeart className="heart-icon filled" />
                    ) : (
                        <AiOutlineHeart className="heart-icon" />
                    )}
                </button>
            </div>
            <div className="tv-show-info">
                <h3 className="tv-show-title">{title}</h3>
                <div className="tv-show-meta">
                    {year && <span className="year-badge">{year}</span>}
                    {renderRating()}
                </div>
            </div>
        </div>
    );
};

export default TvShow;
